class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.classList.add('overflow-hidden');

    // 次のイベントループでbodyクリックリスナーを追加（現在のクリックイベントが伝播しないように）
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 0);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    // アニメーションのためにclosingクラスを追加
    this.detailsContainer.classList.add('closing');

    // トランジション時間後にopen属性を削除
    const modal = this.detailsContainer.querySelector('.search-modal');
    const transitionDuration = modal ? parseFloat(getComputedStyle(modal).transitionDuration) * 1000 : 400;

    setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
      this.detailsContainer.classList.remove('closing');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');

    }, transitionDuration);
  }
}

customElements.define('details-modal', DetailsModal);
